import type { SystemStyleObject, Theme } from '@mui/system';

// MUI X Data Grid v9 styling-migration helpers. v9 reworked several defaults
// that the app relied on pre-upgrade; these fragments restore the v6 look.

// MUI X Data Grid v9 separates pinned columns from the rest with a 1px border
// (.MuiDataGrid-cell--withLeftBorder / --withRightBorder) and a scroll shadow
// (.MuiDataGrid-scrollShadow--horizontal), controlled by the
// `pinnedColumnsSectionSeparator` prop which defaults to 'border-and-shadow'.
// v6 had no border and rendered the shadow on the now-removed
// .MuiDataGrid-pinnedColumns container. This fragment suppresses the v9
// separator so pinned columns blend in like they did pre-upgrade.
export const suppressPinnedColumnSeparatorSx: SystemStyleObject<Theme> = {
  '& .MuiDataGrid-cell--withLeftBorder, & .MuiDataGrid-columnHeader--withLeftBorder, & .MuiDataGrid-cell--withRightBorder, & .MuiDataGrid-columnHeader--withRightBorder':
    {
      borderLeft: 'none',
      borderRight: 'none',
    },
  '& .MuiDataGrid-scrollShadow--horizontal': {
    display: 'none',
  },
};

// v9 renders a resize separator (.MuiDataGrid-columnSeparator, a 1px line) on
// every column with `opacity: 1`. v6 kept these hidden until the header was
// hovered. This fragment restores that: hidden by default, shown on hover for
// resizable columns only.
export const hideColumnSeparatorsSx: SystemStyleObject<Theme> = {
  '& .MuiDataGrid-columnSeparator': {
    opacity: 0,
  },
  '& .MuiDataGrid-columnHeader:hover .MuiDataGrid-columnSeparator--resizable': {
    opacity: 1,
  },
};
